import React from 'react';
import './QRCustomization.css';

const QRCustomization = ({ customization, setCustomization, applyPreset, logo, setLogo }) => {
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setLogo(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeLogo = () => {
    setLogo(null);
  };

  return (
    <div className="qr-customization">
      <h3>Visual Customization</h3>

      <div className="presets">
        <label>Quick Presets</label>
        <div className="preset-buttons">
          <button onClick={() => applyPreset('default')}>Default</button>
          <button onClick={() => applyPreset('dark')}>Dark</button>
          <button onClick={() => applyPreset('light')}>Light</button>
          <button onClick={() => applyPreset('blue')}>Blue</button>
        </div>
      </div>

      <div className="color-controls">
        <div className="color-input">
          <label>Foreground Color</label>
          <div className="color-picker-group">
            <input
              type="color"
              value={customization.fgColor}
              onChange={(e) => setCustomization({ ...customization, fgColor: e.target.value })}
            />
            <input
              type="text"
              value={customization.fgColor}
              onChange={(e) => setCustomization({ ...customization, fgColor: e.target.value })}
              placeholder="#000000"
            />
          </div>
        </div>

        <div className="color-input">
          <label>Background Color</label>
          <div className="color-picker-group">
            <input
              type="color"
              value={customization.bgColor}
              onChange={(e) => setCustomization({ ...customization, bgColor: e.target.value })}
              disabled={customization.transparentBg}
            />
            <input
              type="text"
              value={customization.bgColor}
              onChange={(e) => setCustomization({ ...customization, bgColor: e.target.value })}
              placeholder="#ffffff"
              disabled={customization.transparentBg}
            />
          </div>
        </div>

        <div className="checkbox-group">
          <label>
            <input
              type="checkbox"
              checked={customization.transparentBg}
              onChange={(e) => setCustomization({ ...customization, transparentBg: e.target.checked })}
            />
            Transparent Background
          </label>
        </div>
      </div>

      <div className="gradient-controls">
        <label>Gradient Type</label>
        <select
          value={customization.gradientType}
          onChange={(e) => setCustomization({ ...customization, gradientType: e.target.value })}
        >
          <option value="none">None</option>
          <option value="linear">Linear</option>
          <option value="radial">Radial</option>
        </select>

        {customization.gradientType !== 'none' && (
          <div className="gradient-colors">
            <div className="color-input">
              <label>Gradient Start</label>
              <input
                type="color"
                value={customization.gradientColors[0]}
                onChange={(e) => setCustomization({
                  ...customization,
                  gradientColors: [e.target.value, customization.gradientColors[1]]
                })}
              />
            </div>
            <div className="color-input">
              <label>Gradient End</label>
              <input
                type="color"
                value={customization.gradientColors[1]}
                onChange={(e) => setCustomization({
                  ...customization,
                  gradientColors: [customization.gradientColors[0], e.target.value]
                })}
              />
            </div>
          </div>
        )}
      </div>

      <div className="shape-controls">
        <div className="checkbox-group">
          <label>
            <input
              type="checkbox"
              checked={customization.roundedModules}
              onChange={(e) => setCustomization({ ...customization, roundedModules: e.target.checked })}
            />
            Rounded Modules (Dots)
          </label>
        </div>

        <div className="checkbox-group">
          <label>
            <input
              type="checkbox"
              checked={customization.roundedFinders}
              onChange={(e) => setCustomization({ ...customization, roundedFinders: e.target.checked })}
            />
            Rounded Finder Patterns
          </label>
        </div>
      </div>

      <div className="logo-controls">
        <label>Center Logo</label>
        <p className="logo-hint">Logo will be embedded at center with high error correction. Max 25% of QR area.</p>

        {!logo ? (
          <div className="logo-upload">
            <input
              type="file"
              accept="image/*"
              onChange={handleLogoUpload}
              id="logo-upload"
              style={{ display: 'none' }}
            />
            <label htmlFor="logo-upload" className="upload-btn">
              📁 Upload Logo
            </label>
          </div>
        ) : (
          <div className="logo-preview">
            <img src={logo} alt="Logo" />
            <button onClick={removeLogo} className="remove-logo">✕ Remove</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRCustomization;
